(ns frontend.view.modals.attachments.view
  (:require
   [common.localization :as loc]
   [ui.components.loading-spinner.view :as spinner]
   [common.entity :as entity]
   [frontend.state.current-session :as session]
   [frontend.view.components.upload :as upload]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.logging :as logging]
   [frontend.actions.common :as common-actions]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.dom-globals :as dg]
   [ui.util :as uu]))

(defonce modal-key :attachment-modal)

(defn existing-attachments
  [state entity-attachments]
  (let [files (:files @state)]
    [:div
     {:class "pb-2 flex flex-col gap-2"}
     [:span
      {:class "font-semibold"}
      (loc/tr :select-from-associated-files)]
     [:ul
      {:class "flex flex-col gap-2"}
      (doall
       (for [attachment-id entity-attachments
             :let [attachment (get @session/entities attachment-id)
                   selected? (boolean (some #{attachment-id} files))]]
         ^{:key (str "attachment-modal-" attachment-id)}
         [:li
          {:class "flex gap-2 items-center"
           :on-click (fn [e]
                       (swap! state assoc
                         :files
                         (if-not selected?
                           (conj files attachment-id)
                           (disj files attachment-id)))
                       (deref state)
                       (dg/prevent-and-stop e))}
          [:i
           {:class (uu/cm :fas (if selected? :fa-check-square :fa-square))}]
          [:span
           {:class "font-bold"}
           [:span
            (entity/display-string attachment)]]]))]
     [:span
      {:class "text-base-light-text-paler"}
      (loc/tr :or-upload-files)]]))

(defn add-indicator!
  [local-atom token name]
  (swap! local-atom assoc-in
    [:uploading name]
    {:token token
     :name  name}))

(defn remove-indicator!
  [local-atom name id]
  (swap! local-atom assoc-in
    [:uploading name]
    (merge {:name name}
           (if (> id 0)
             {:db/id id}
             {:error (loc/tr :error-code id)}))))

(defn add-attachment!
  [{:keys [local-atom]} e]
  (let [file (aget (:files e) 0)
        name (.-name file)
        attachment {:filename    name
                    :description nil
                    :file        file}
        token-success! (fn [token]
                         (add-indicator! local-atom token name)
                         (attachment-actions/*=>add-attachment
                          {:multipart-params (assoc attachment :token token)}
                          (fn [resp]
                            (let [new-id (->> resp
                                              :body
                                              :db/id)]
                              (swap! local-atom assoc :files (conj (:files @local-atom) new-id))
                              (remove-indicator! local-atom name new-id))

                            ;;TODO show success-bar
                          )
                          (fn [e]
                            (logging/error "Error in uploading attachment" e)
                            (remove-indicator! local-atom name -1) ;; TODO: proper error code
                            ;;TODO show error-bar
                          )
                         ))]
    (common-actions/*<-create-op-token nil
                                       token-success!
                                       (fn [e]
                                         ;;TODO show error-bar
                                         (logging/error "resp token=" e)))))

(defn indicators
  [local-atom]
  (let [files (:files @local-atom)]
    [:ul
     {:class "pb-2 flex flex-col gap-2"}
     (doall
      (for [[name {:keys [:token :db/id :error]}] (:uploading @local-atom)
            :let [selected? (boolean (some #{id} files))]]
        ^{:key (str "uploading-indicator-" name)}
        [:li
         {:class "flex items-center gap-2"}
         (if token
           [spinner/circle]
           [:i
            {:class (uu/cm :fas (if selected? :fa-check-square :fa-square))
             :on-click   (fn [e]
                           (swap! local-atom assoc
                             :files
                             (if-not selected?
                               (conj files id)
                               (disj files id)))
                           (deref local-atom)
                           (dg/prevent-and-stop e))}])
         [:span
          {:class "font-bold"}
          [:span
           (if token
             (str "   " (loc/tr :uploading) " " name)
             name)]]]))]))

(defn upload-block
  [state]
  [upload/upload-zone
   {:css-class  "attachments-module-upload-zone"
    :on-change! (fn [e]
                  (add-attachment! {:local-atom state} e))}])

(defn view
  [{:keys [_shown? _close-modal! _props state _topmost?]}]
  (reset! state {:files #{}})
  (let []
    (fn [{:keys [shown? close-modal! props state topmost?]}]
      (let [{:keys [title-text  primary-button-text on-primary-submit! entity-attachments]} props
            files-count (count (:files @state))]
        [modal/view
         {:visible?      (and shown? topmost?)
          ;on show ???          (reset! state {:files #{}}))
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (or title-text
             (loc/tr :select-attachments))
         [:<>
          (when entity-attachments
            [existing-attachments state entity-attachments])
          [indicators state]
          [upload-block state]]
         [:<>
          [:div
           {:class "flex gap-3"}
           [button/secondary-hollow
            {:on-click close-modal!}
            (loc/tr :cancel)]]
          [:div
           {:class "flex justify-center items-center gap-3"}
           [:span
            (if (= 1 files-count)
              (loc/tr :attachment-select-summary__single)
              (loc/tr :attachment-select-summary [files-count]))]]

          [:div
           {:class "flex gap-3 justify-end"}
           [button/primary-solid
            {:disabled? (< (count (:files @state)) 1)
             :on-click  (fn [_]
                          (on-primary-submit! (:files @state))
                          (close-modal!))}
            (or primary-button-text
                (loc/tr :select-attachments-button))]]]]))))

